import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

/** True when env vars look like a real Keycloak deployment (not template placeholders). */
export function isKeycloakConfigured(): boolean {
  const url = import.meta.env.VITE_KEYCLOAK_URL;
  const realm = import.meta.env.VITE_KEYCLOAK_REALM;
  const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID;
  return Boolean(
    url &&
      url !== 'https://your-keycloak-host' &&
      realm &&
      realm !== 'your-realm' &&
      clientId &&
      clientId !== 'ggj-b2b-placeholder',
  );
}

export default keycloak;
